import { useState } from "react";
import { connect } from "react-redux";
import { ReactComponent as Sticker } from "icons/sticker.svg";
import { EanCodeStickerModal, QrCodeStickerModal, ProductPackageStickerModal } from "components";

import StyledStickers from "./styles";

const Stickers = ({ data }) => {
  const [is_open_qr_code_modal, handleOpenQrCodeModal] = useState(false);
  const [is_open_product_sticker_modal, handleOpenProductStickerModal] =
    useState(false);
  const [is_open_ean_code_modal, handleOpenEanCodeModal] = useState(false);

  return (
    <StyledStickers>
      <div className="dashboard">
        <header className="dashboard__header dashboard__header--edit">
          <div className="icon__container">
            <Sticker />
          </div>
          <h2 className="dashboard__title heading">Naklejki</h2>
        </header>
        <div className="stickers-container">
         {data?.ean && <button
            type="button"
            className="btn-sticker"
            onClick={() => handleOpenEanCodeModal(true)}
          >
            Naklejka Ean
          </button>}
          {is_open_ean_code_modal && (
            <EanCodeStickerModal
              data={data}
              handleClose={() => handleOpenEanCodeModal(false)}
              initialValues={{ quantity: 1 }}
            />
          )}
          {data?.has_qr_code && (
            <button
              type="button"
              className="btn-sticker"
              onClick={() => handleOpenQrCodeModal(true)}
            >
              Naklejka QR Code
            </button>
          )}
          {is_open_qr_code_modal && (
            <QrCodeStickerModal
              data={data}
              handleClose={() => handleOpenQrCodeModal(false)}
              initialValues={{ quantity: 1 }}
            />
          )}
          <button
            type="button"
            className="btn-sticker"
            onClick={() => handleOpenProductStickerModal(true)}
          >
            Naklejka na paczke
          </button>
          {is_open_product_sticker_modal && (
            <ProductPackageStickerModal
              data={data}
              handleClose={() => handleOpenProductStickerModal(false)}
              initialValues={{ quantity: 1 }}
            />
          )}
        </div>
      </div>
    </StyledStickers>
  );
};

export default connect(({ edit_product: { data } }) => ({ data }))(Stickers);
